import { useState } from "react";

export function useCountsById(initial: Map<string, number>) {
  const [counts, setCounts] = useState(initial);

  const increment = (id: string) => {
    setCounts((prev) => {
      const nextCount = (prev.get(id) ?? 1) + 1;
      return new Map(prev).set(id, nextCount);
    });
  };

  const decrement = (id: string) => {
    setCounts((prev) => {
      const nextCount = Math.max(1, (prev.get(id) ?? 1) - 1);
      return new Map(prev).set(id, nextCount);
    });
  };

  return { counts, increment, decrement };
}
